var _this = this;
import * as tslib_1 from "tslib";
import { bookapiInsurancesActionTypes } from './ActionTypes';
import { BookapiInsurancesResponse } from '../../../globalTypes';
import { BookapiInsuranceFactory } from '../../util/Factory/BookapiInsuranceFactory';
export var getBookapiInsurances = function (bookapiInsurancesRequest) {
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var bookapiInsurancesResponse, res, response, currentKey, currentInsurances, error_1, receiveBookapiInsurancesState;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    bookapiInsurancesResponse = new BookapiInsurancesResponse();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(bookapiInsurancesRequest.url, {
                            method: 'POST',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            body: 'offerKey=' + encodeURIComponent(bookapiInsurancesRequest.offerKey) + '&productType=' + bookapiInsurancesRequest.productType,
                        })];
                case 2:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    response = _a.sent();
                    for (currentKey in response) {
                        if (response.hasOwnProperty(currentKey)) {
                            currentInsurances = BookapiInsuranceFactory.createArrayOfInsurances(response[currentKey]);
                            if (currentKey === '0') {
                                bookapiInsurancesResponse.setInsurancesForAll(currentInsurances);
                            }
                            else {
                                bookapiInsurancesResponse.setInsurancesForOnePax(parseInt(currentKey), currentInsurances);
                            }
                        }
                    }
                    bookapiInsurancesResponse.setIsOk(true);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    bookapiInsurancesResponse.setIsOk(false);
                    return [3 /*break*/, 5];
                case 5:
                    receiveBookapiInsurancesState = {
                        'type': bookapiInsurancesActionTypes.RECEIVE_BOOKAPI_INSURANCES_STATE,
                        'bookapiInsurancesResponse': bookapiInsurancesResponse
                    };
                    return [2 /*return*/, dispatch(receiveBookapiInsurancesState)];
            }
        });
    }); };
};
